import { ModalService } from '@/components/moda-lInvoker';
import GlobalCampaignMailEditorDialog, { CampaignMailEditorData } from './GlobalCampaignMailEditorDialog';
import type { AttachmentsModel } from '@/stores/mailEditorStore';

export interface GlobalCampaignMailEditorOptions {
  /** 邮件主题 */
  subject?: string;
  /** 邮件内容 */
  content?: string;
  /** 附件列表 */
  attachments?: AttachmentsModel[];
  /** Update 按钮回调 */
  onUpdate?: (data: CampaignMailEditorData) => Promise<void>;
  /** 容器名称，默认为 'default' */
  containerName?: string;
}

/**
 * 全局营销活动邮件编辑器服务
 * 使用全局 Modal 系统打开营销活动邮件编辑器，解决弹窗中右键菜单定位问题
 */
export const GlobalCampaignMailEditorService = {
  /**
   * 打开全局营销活动邮件编辑器
   * @param options 配置选项
   * @returns Promise，编辑器关闭时 resolve
   */
  open(options: GlobalCampaignMailEditorOptions = {}): Promise<void> {
    return ModalService.open(GlobalCampaignMailEditorDialog, {}, { containerName: options.containerName || 'default' });
  },
};

export default GlobalCampaignMailEditorService;
